import { parse } from 'date-fns';

export function convertRubyDateToISO(date: string): string {
  if (date === '' || date === null) {
    return '';
  }

  return parse(date, 'yyyy-MM-dd', new Date()).toISOString();
}

/**
 * Use this instead of `new Date()` to make it easier to mock dates in
 * application code without affecting library code.
 *
 * The fetch-mock and mockdate libraries do not appear to play well together.
 *
 * @returns The current date and time.
 *
 * @example
 * // Modules that are mocked with jest.mock are mocked only for the file that calls jest.mock.
 * jest.mock('utils/date', () => ({
 *   getCurrentDateTime: () => new Date(2021, 7, 1),
 * }));
 */
export function getCurrentDateTime(): Date {
  return new Date();
}
